import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TagDefinition } from '@app/models/automation/tag-definition.model';
import { BaseDeviceType } from '@app/models/disciplinemanagement/base-device-type.model';

@Component({
  selector: 'app-tag-definition-details',
  templateUrl: './tag-definition-details.component.html',
  styleUrls: ['./tag-definition-details.component.scss']
})
export class TagDefinitionDetailsComponent implements OnInit {
  @Input() selectedTagDefinition: TagDefinition;
  @Input() filteredBaseDeviceTypes: BaseDeviceType[] = [];

  @Output() edit = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  onEdit() {
    this.edit.emit();
  }
}
